import React from 'react';

import ChatUtils from '../utils/ChatUtils';

class KeywordSelector extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      keywords: props.keywords,
      // oneClickMenu: Object.keys(props.keywords)
      //   .filter((k) => props.keywords[k] !== 'back')
      //   .length === 1,
      disabled: true,
      open: true,
    };
    this.ee = props.ee;
    this.setupListeners();
  }

  setupListeners() {
    this.ee.on('hu-lb-enable-input', () => {
      this.setState({
        disabled: false,
        // open: false,
      });
    });

    this.ee.on('hu-lb-disable-input', () => {
      this.setState({
        disabled: true,
        // open: false,
      });
    });
  }

  clickHandler(keyword) {
    if (!this.state.disabled) {
      this.setState({
        disabled: true,
        // open: false,
      });
      ChatUtils.sendMessage(keyword);
    }
  }

  getKeyButton(keyword) {
    const { keywords } = this.props;
    return (
      <button 
        className="keyword-button hu-background-color_light hu-color_accent"
        onClick={() => this.clickHandler(keyword)}
      >
        {keyword}
      </button>
    );
  }

  toggleMenu() {
    const state = this.state.open;
    this.setState({
      // open: !state,
    });
  }
  
  render() {
    const { keywords } = this.props;
    const { disabled, open, oneClickMenu } = this.state;
    const keys = Object.keys(keywords).filter((k) => k !== '#back' && k !== '#init');
    const bulbIcon = (
      <svg className="bulb-icon hu-fill_accent" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
      viewBox="0 0 81.6 82.1" enable-background="new 0 0 81.6 82.1" xmlSpace="preserve">
        <g>
          <path d="M67.3,45.3c-2.8,4.6-6.5,8.2-11.2,10.8V61c0,1.6-0.6,2.9-1.7,4.1s-2.5,1.7-4.1,1.7H31.3c-1.6,0-2.9-0.6-4.1-1.7
            s-1.7-2.5-1.7-4.1v-4.9c-4.7-2.6-8.4-6.2-11.2-10.8c-2.8-4.6-4.1-9.6-4.1-15c0-8.2,3-15.3,9-21.1c6-5.8,13.2-8.7,21.6-8.7
            c8.5,0,15.7,2.9,21.6,8.7c6,5.8,9,12.8,9,21.1C71.4,35.6,70.1,40.7,67.3,45.3z M63.8,39.6c1.3-3,1.9-6.1,1.9-9.3
            c0-3.2-0.6-6.4-1.9-9.3c-1.3-2.9-3.1-5.4-5.3-7.7c-2.3-2.2-4.9-4-7.9-5.2c-3.1-1.3-6.3-1.9-9.7-1.9c-3.4,0-6.6,0.6-9.7,1.9
            c-3,1.2-5.6,2.9-7.9,5.2c-2.3,2.2-4.1,4.8-5.3,7.7c-1.3,3-1.9,6.1-1.9,9.3c0,3.2,0.6,6.4,1.9,9.3c1.3,2.9,3.1,5.4,5.3,7.7
            c2.3,2.2,4.9,4,7.9,5.2l0.2,0.1V61h19.1v-8.5l0.2-0.1c3-1.2,5.6-2.9,7.9-5.2c2.3-2.2,3.4-3.3,3.4-3.3S62.5,42.4,63.8,39.6z
              M53.1,77.1c0.6,0.6,0.8,1.2,0.8,2c0,0.8-0.3,1.5-0.8,2S51.8,82,51,82H30.6c-0.8,0-1.5-0.3-2-0.8s-0.8-1.2-0.8-2
            c0-0.8,0.3-1.5,0.8-2s1.2-0.8,2-0.8H51C51.8,76.3,52.5,76.6,53.1,77.1z"/>
        </g>
      </svg>
    );
    const crossIcon = (
      <svg className="cross-icon hu-fill_light" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
      viewBox="0 0 81.6 82.1" enable-background="new 0 0 81.6 82.1" xmlSpace="preserve">
        <g>
          <path d="M65.5,61.8c0.6,0.6,1,1.3,1,2.2s-0.3,1.6-0.9,2.2c-0.6,0.6-1.4,0.9-2.2,0.9s-1.6-0.3-2.2-1L40.8,45.9L20.5,66.2
            c-0.6,0.6-1.3,1-2.2,1s-1.6-0.3-2.2-0.9c-0.6-0.6-0.9-1.4-0.9-2.2s0.3-1.6,1-2.2l20.3-20.3L16.1,21.1c-0.6-0.6-1-1.3-1-2.2
            s0.3-1.6,0.9-2.2c0.6-0.6,1.4-0.9,2.2-0.9s1.6,0.3,2.2,1L40.8,37l20.3-20.3c0.6-0.6,1.3-1,2.2-1s1.6,0.3,2.2,0.9
            c0.6,0.6,0.9,1.4,0.9,2.2s-0.3,1.6-1,2.2L45.3,41.5L65.5,61.8z"/>
        </g>
      </svg>
    )

    if (keys.length > 0)
      return (
        <div className={`hu-keyword-selector${disabled ? ' disabled' : ''}${open ? ' open' : ''}`}>
          <button
            className="keyword-switch hu-s-18 hu-color_contrast" 
            onClick={this.toggleMenu.bind(this)}
          >
            {bulbIcon}
            {crossIcon}
            <span className="keyword-switch-text">Menu</span>
          </button>
          <div className="keyword-menu">
            <div className="keyword-buttons">
              { keys.map(this.getKeyButton.bind(this)) }
            </div>
          </div>
        </div>
      );
    else
      return null;
  }
}

export default KeywordSelector;


// WEBPACK FOOTER //
// ./app/js/components/keywords/KeywordSelector.js